// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/Opengraph/MetatagsCards/Twitter.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/Opengraph/MetatagsCards/Twitter.tsx");
  import.meta.hot.lastModified = "1717182690460.4846";
}
// REMIX HMR END

export function Twitter({
  title,
  description,
  image,
  origin
}) {
  return <div id="twitter">
      <div className="card-twitter min-[770px]:w-[504px] max-[669px]:flex max-[669px]:justify-between cursor-pointer group">
        <div className="w-10 h-10 bg-[#EBF1FA] rounded-full shrink-0 mr-1 min-[770px]:hidden"></div>
        <div className="w-full">
          <div className="card-twitter-image min-[770px]:h-[252px] min-[770px]:w-[504px] h-[150px] w-full border border-gray-200 rounded-t-lg group-hover:border-gray-300 duration-300 bg-contain bg-center bg-cover" style={{
          backgroundImage: `url("${image}")`
        }}></div>
          <div className="border-x border-b border-gray-200 px-[14px] py-2 text-[#606770] text-[12px] leading-3 rounded-b-lg group-hover:border-gray-300 duration-300">
            <p className="text-sm mt-1 text-[#1d2129] min-[770px]:font-bold leading-[1.3em] break-words truncate text-ellipsis">
              {title}
            </p>
            <span className="text-sm leading-[18px] mt-1 mb-1 text-black hidden min-[770px]:block break-words" dangerouslySetInnerHTML={{
            __html: description
          }} />
            <span className="text-sm text-[#8899A6]">{origin}</span>
          </div>
        </div>
      </div>
    </div>;
}
_c = Twitter;
var _c;
$RefreshReg$(_c, "Twitter");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;